import React from "react";
import {Field} from "redux-form";
import MultipleSelect from "../MultipleSelect";

const statusOptions = [
    {_id: 'active', name: 'Aktiv'},
    {_id: 'cashed', name: 'Eingelöst'},
    {_id: 'inactive', name: 'Inaktiv'},
];
const VoucherStatusSelect = (props) => {

    return  <Field
        format={value => Array.isArray(value) ? value : []}
        name={props.fieldName}
        component={MultipleSelect}
        label={'Status'}
        fullWidth
        accessorValue={"_id"}
        accessorLabel={'name'}
        options={statusOptions}
    />;
};

export default VoucherStatusSelect;